export const getDeclension = (number: number, titles: string[]) => {
  const cases = [2, 0, 1, 1, 1, 2];
  const index = (number % 100 > 4 && number % 100 < 20) 
    ? 2 
    : cases[Math.min(number % 10, 5)];
  return `${number} ${titles[index]}`;
};

const units = {
  ru: ['байт', 'КБ', 'МБ', 'ГБ', 'ТБ', 'ПБ', 'ЭБ', 'ЗБ', 'ИБ'],
  en: ['byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  es: ['byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  kg: ['байт', 'КБ', 'МБ', 'ГБ', 'ТБ', 'ПБ', 'ЭБ', 'ЗБ', 'ИБ']
};

export const formatBytes = (bytes: number, locale: string, decimals = 1) => {
  if (bytes === 0) return '0 Байт';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = units[locale as keyof typeof units];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};


export const countFileTypes = (arr: any[]) => {
  const counts: any = {};
    
  arr.forEach((item: any) => {
    // Извлекаем расширение файла
    const fileType = item.key.split(' ')[0].toUpperCase();
    counts[fileType as keyof typeof counts] = (counts[fileType as keyof typeof counts] || 0) + 1;
  });
    
  return Object.keys(counts)
    .sort() // сортировка по алфавиту (опционально)
    .map(type => `${type} ${counts[type]}`)
    .join(', ');
}
